import { Component, OnInit, OnDestroy } from '@angular/core';
import { I18nModule, Page, ProductSearchService } from '@spartacus/core';
import { PageLayoutService } from '@spartacus/storefront';
import { ActivatedRoute } from '@angular/router';
import { map, switchMap, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'search-pages-page-name',
  standalone: true,
  imports: [I18nModule, CommonModule],
  templateUrl: './search-pages-page-name.component.html',
  styleUrls: ['./search-pages-page-name.component.scss'],
})
export class SearchPagesPageNameComponent implements OnInit, OnDestroy {
  templateName$ = this.pageLayoutService.page$.pipe(map((page: Page) => page.template ?? ''));

  pageName$ = this.templateName$.pipe(
    switchMap((template: string) =>
      this.productSearchService.getResults().pipe(
        map((data: any) => {
          if (template === 'SearchResultsListPageTemplate' || template === 'SearchResultsGridPageTemplate') {
            return `"${data.freeTextSearch || ''}"`;
          }
          return data?.breadcrumbs?.[0]?.facetValueName || '';
        }),
      ),
    ),
  );

  currentTerm = '';
  subscription = new Subscription();

  constructor(
    private productSearchService: ProductSearchService,
    private pageLayoutService: PageLayoutService,
    private activeRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.getCurrentTerm();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getCurrentTerm(): void {
    this.subscription.add(
      this.activeRoute.params.subscribe(params => {
        this.currentTerm = params['query'] || '';
      }),
    );
  }
}
